import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.js';
import * as Sentry from '@sentry/react';

if (window.location.hostname === 'vantaribolta.is') {
    Sentry.init({
        dsn: 'https://bd05fd4922e39fa2db2d5a3a58771b31@o4506966273228800.ingest.us.sentry.io/4509549913243648',
        integrations: [
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
        ],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <App />
    </StrictMode>
);
